export const urls = {
  GET_PROIZVODE: 'KlijentProizvod/vrati_klijentproizvod_za_id_kupca',
  INSERT_PROIZVODA: 'KlijentProizvod/unos_klijentproizvoda',
  UPDATE_PROIZVODA: 'KlijentProizvod/izmena_klijentproizvoda',
  DELETE_PROIZVODA: 'KlijentProizvod/brisanje_klijentproizvoda',
  INSERT_DOKUMENTA: 'Dokumenta/unos_dokumenta',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
  GET_DOKUMENTA: 'Dokumenta/vrati_dokumenta_objekta',
  DOWNLOAD_DOKUMENT:
    'Dokumenta/konvertovanje_base64_sa_id_dokumenta_servisnog_zahteva',
};
